import { AdhocClaimsInterface } from '@/utils/interfaces'
import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

@Component({
  computed: {
    ...mapGetters(['accessClaims'])
  }
})
export class AuthMixin extends Vue {
  accessClaims!: AdhocClaimsInterface

  hasPermission(roles) {
    return roles.some(r => this.accessClaims?.roles?.includes(r))
  }

  /** Whether this user may refund a single card from a payment. */
  get canRefundCards(): boolean {
    if (
      this.$store?.getters?.currentMerchant?.check_custom_roles &&
      this.hasPermission(['is_payment_refund_allowed'])
    ) {
      return true
    }

    return this.hasPermission(['admin', 'super_admin'])
  }
}
